import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from "@ctms/api.service";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {SpinnerComponent} from "@shared/components/spinner/spinner.component";
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {NgbNavModule} from "@ng-bootstrap/ng-bootstrap";
import {Paginator} from "@shared/components/paginator/paginator.component";
import {PatientRecordWeightIndicator} from "@shared/api/models/query/patient-record-weight-indicator.model";
import {PatientRecordWeightIndicatorsService} from "@shared/api/services/v2/patient-record-weight-indicators.service";
import {PatientRecordWeightIndicatorUpdate} from "@shared/api/models/command/patient-record-weight-indicator.model";


@Component({
    selector: 'cdss-patient-records-weight',
    imports: [CommonModule, ReactiveFormsModule, SpinnerComponent, NgSelectModule, NgxDatatableModule, NgbNavModule],
    providers: [ApiService],
    standalone: true,
    templateUrl: './patient-records-weight.component.html'
})
export class PatientRecordsWeightComponent extends Paginator {

    editing: boolean = false
    editingId?: number = null
    @Input() patientId: number

    form: FormGroup

    constructor(
        private toastr: ToastrService,
        service: PatientRecordWeightIndicatorsService
    ) {
        super()
        this.service = service
    }

    ngOnInit(): void {
        this.filterForm = new FormGroup({
        });
        this.form = new FormGroup({
            height: new FormControl(),
            weight: new FormControl('', Validators.required),
            weightForHeightPercentage: new FormControl(),
            bmi: new FormControl(),
            bmiPercentage: new FormControl(),
            measuredBy: new FormControl(),
            measuredAt: new FormControl(),
        })

        this.service.setParent(this.patientId)
        this.refreshRows()
    }

    edit(row: PatientRecordWeightIndicator) {
        this.editingId = row.id
        const data = {
            height: row.height,
            weight: row.weight,
            weightForHeightPercentage: row.weightForHeightPercentage,
            bmi: row.bmi,
            bmiPercentage: row.bmiPercentage,
            measuredBy: row.measuredBy == null ? null : "" + row.measuredBy,
            measuredAt: row.measuredAt == null ? null : (new Date(row.measuredAt)).toISOString().slice(0, 16),
        }
        this.form.patchValue(data)
        this.editing = true
    }

    add() {
        this.editingId = null
        this.form.reset()
        this.editing = true
    }

    cancel() {
        this.editing = false
    }

    submit() {
        if (this.form.valid) {
            this.loading = true
            const value: PatientRecordWeightIndicatorUpdate = {
                height: this.form.value.height,
                weight: this.form.value.weight,
                weightForHeightPercentage: this.form.value.weightForHeightPercentage,
                bmi: this.form.value.bmi,
                bmiPercentage: this.form.value.bmiPercentage,
                measuredBy: this.form.value.measuredBy,
                measuredAt: this.form.value.measuredAt,
            }
            if (this.editingId == null) {
                this.service.create(value).subscribe({
                    next: () => {
                        this.refreshRows()
                        this.toastr.success('Weight record successfully created', 'Success');
                        this.editing = false
                        this.loading = false
                    }
                })
            } else {
                this.service.update(this.editingId, value).subscribe({
                    next: () => {
                        this.refreshRows()
                        this.toastr.success('Weight record successfully updated', 'Success');
                        this.editing = false
                        this.loading = false
                    }
                })
            }
        } else {
            this.form.markAllAsTouched()
            this.toastr.error('Please fill all the required fields');
        }
    }
}
